export enum Role {
  Agent = 'agent',
  Admin = 'admin',
}
